import { ReactNode } from 'react'
import { MdClose as CloseIcon } from 'react-icons/md'
import cx from 'classnames'
import { Modal, ModalHeader, ModalBody, ModalFooter, ModalProps } from 'reactstrap'
import styles from './styles.module.scss'

export interface ModalDialogProps extends ModalProps {
  title?: string
  toggle?: React.MouseEventHandler<any>
  footer?: ReactNode
  subTitle?: ReactNode
  position?: 'left' | 'top' | 'right' | 'bottom' | 'center'
  footerStyle?: React.CSSProperties
  headless?: boolean
  headerClassName?: string
  size?: 'xl' | 'lg' | 'md' | 'sm' | 'xs'
  bodyClassName?: string
  backdrop?: 'static' | boolean
}

const POSITION_CLASSES = {
  left: styles.modalLeft,
  top: styles.modalTop,
  right: styles.modalRight,
  bottom: styles.modalBottom,
  center: 'modal-dialog-centered' // this is bootstrap class
}

const ModalDialog = ({
  headerClassName,
  bodyClassName,
  toggle = () => {},
  backdrop,
  position = 'center',
  className,
  title,
  children,
  footer,
  footerStyle,
  headless = false,
  subTitle,
  size,
  ...props
}: ModalDialogProps) => {
  const classes = [styles.hfModalDialog]
  if (POSITION_CLASSES[position]) {
    classes.push(POSITION_CLASSES[position])
  }

  const closeButton = <CloseIcon className={styles.closeIcon} onClick={toggle} />

  return (
    <Modal
      backdrop={backdrop}
      size={size}
      zIndex={10000}
      {...props}
      toggle={toggle}
      className={cx(...classes, className)}
    >
      {headless ? null : (
        <ModalHeader className={headerClassName ?? ''} toggle={toggle} close={closeButton}>
          {title}
          {subTitle && <div>{subTitle}</div>}
        </ModalHeader>
      )}
      <ModalBody className={bodyClassName}>{children}</ModalBody>
      {footer ? <ModalFooter style={footerStyle}>{footer}</ModalFooter> : null}
    </Modal>
  )
}

export default ModalDialog
